<template>
  <div class="traitranks-page">
    <TraitRanksBulls
      v-if="type === 'bulls' || type === 'teens'"
      :type="type"
      @update:type="onUpdateType"
    />
    <TraitRanksApesTraits
      v-if="type === 'apes_traits'"
      @update:type="onUpdateType"
    />
    <TraitRanksApes
      v-if="type === 'apes'"
      @update:type="onUpdateType"
    />
  </div>
</template>

<script>
import TraitRanksBulls from "@/components/TraitRanks/TraitRanksTabs/TraitRanksBulls.vue";
import { computed, defineComponent, ref } from "vue-demi";
import { useRoute, useRouter } from "vue-router";
import TraitRanksApesTraits from "@/components/TraitRanks/TraitRanksTabs/TraitRanksApesTraits.vue";
import TraitRanksApes from "@/components/TraitRanks/TraitRanksTabs/TraitRanksApes.vue";


export default defineComponent({
  components: { TraitRanksBulls,TraitRanksApes, TraitRanksApesTraits },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const type = ref('bulls')
    const onUpdateType = (newType) => {
      type.value = newType
    }
    return { type, onUpdateType }
  }

})
</script>
